import { createContext, useContext, type PropsWithChildren } from 'react';
import { FaqItemHeader } from './FaqItemHeader';
import { FaqItemContent } from './FaqItemContent';
import { useFaq } from './Faq';
import clsx from 'clsx';

type FaqItemProps = PropsWithChildren & {
  id: string;
};

type FaqItemContext = {
  id: string;
}

const FaqItemContext = createContext( {
  id: ''
} )

export const useFaqItem = () => useContext( FaqItemContext );

export const FaqItem = ( { children, id }: FaqItemProps ) => {
  const faq = useFaq();

  const Components = Array.isArray( children ) ? children : [ children ];
  const Header = Components.find( c => c?.type?.displayName === FaqItemHeader.displayName );
  const Content = Components.find( c => c?.type?.displayName === FaqItemContent.displayName );

  return (
    <FaqItemContext.Provider value={ {
      id
    } }>
      <div className={ clsx(
        'bg-[#0C102E] border-[1.5px] border-[#FFFFFF20] rounded-[10px] hover:drop-shadow-[0px_0px_6px_rgba(90,125,251,0.40)] transition-all duration-200 w-full',
        {
          'drop-shadow-[0px_0px_6px_rgba(90,125,251,0.40)]': faq.openItemId === id
        }
      ) }>
        {Header}
        { faq.openItemId === id && Content}
      </div>
    </FaqItemContext.Provider>
  )
}
FaqItem.displayName = 'FaqItem';
